const template = require('./hubUsage.html');
require('./hubUsage.scss');
require('matchmedia-ng');
var logger = require('../../common/logging.config');

const WARNING_PERCENT = 0.8;
const MARKETPLACE_URL = 'https://acoustic.com/products/content/';


class HubUsageController {

	constructor($scope, $filter, $translate, matchmedia, tenantRegistryService, contentService, homepageDataService, shellUtil) {
		this.filter = $filter;
		this.tenantRegistryService = tenantRegistryService;
		this.contentService = contentService;
		this.marketplaceURL = MARKETPLACE_URL;
		this.homepageDataService = homepageDataService;

        this.unlimitedText = "Unlimited";
		$translate(this.unlimitedText).then(text => {
			this.unlimitedText = text;
		});
		this.unavailableText = "Unavailable";
		$translate(this.unavailableText).then(text => {
			this.unavailableText = text;
		});
		
		// flags if resource is in warning levels
		this.isStorageWarningLevel = false;
		this.isDataWarningLevel = false;
		
		// flags if an error occurs fetching current value for a resource
		this.isErrorForStorageUsage = false;
		this.isErrorForDataUsage = false;

		// Might reuse this piece of code if needed
		// $scope.unregister = matchmedia.onPhone( mediaQueryList => {
		// //$scope.unregister = matchmedia.onDesktop( mediaQueryList => {
		// 	$scope.isPhone = mediaQueryList.matches;
		// 	if ($scope.isPhone) {
		// 		this.render();
		// 	}
		// 	else {
		// 		this.render();
		// 	}
		// });
		
        this.errorMessages = [];

		this.maxStorage = 10; //GB
		this.maxData = 100; //GB
		this.subscriptionDisplay = "Essentials subscription";
		this.subscription = "base";
		
		// Fetch dashboard max values and subscription
		this.getTenantInformation();
        
		
		// Fetch current storage dashboard value
		this.usedStorage = 0;
		this.getTenantCurrentFileStorage();
		
		if (this.usedStorage > this.maxStorage) {
			this.setErrorMessage("storageExceededAlt", "");
		}
		
		// Fetch current data transfer dashboard value
		this.usedData = 0;
		this.getTenantCurrentDataTransfer();
		
		
		if (this.usedData > this.maxData) {
			this.setErrorMessage("dataTransferExceededAlt", "");
		}
		
		// remove ondesktop listener on teardown
		$scope.$on("$destroy", function() {
			if ($scope.unregister) {
				$scope.unregister();
			}
		});
		
		this.render();
	}
	
	getTenantInformation() {
		var isInfoUpdated = false;
		this.tenantRegistryService.getTenantInformation().then(
			(data) => {
				if (data.maxStorageSize && this.maxStorage !== data.maxStorageSize) {
					isInfoUpdated = true;
					this.maxStorage = data.maxStorageSize;
				}
				if (data.maxDataTransfer && this.maxData !== data.maxDataTransfer) {
					isInfoUpdated = true;
					this.maxData = data.maxDataTransfer;
				}
				
				// get subscription plan
				if (data.tier) {
					const tier = data.tier.toLowerCase();
					if (tier !== this.subscription) {
						isInfoUpdated = true;

						switch (tier) {
						case "base":
							this.subscriptionDisplay = "Essentials subscription";
							this.subscription = tier;
							break;
						case "standard":
							this.subscriptionDisplay = "Standard subscription";
							this.subscription = tier;
							break;
						case "plus":
							this.subscriptionDisplay = "Plus subscription";
							this.subscription = tier;
							break;
						case "trial":
							this.subscriptionDisplay = "Trial subscription";
							this.subscription = tier;
							break;
						default:
							logger.info("hubUsage unrecognized subscription plan: " + tier);
							break;
						}
					}
				}
				
				if (isInfoUpdated) {
					this.render();
				}
			},
			(error) => {
				logger.error('Error retrieving tenant max usage information from server: ' + error);
			}
		);
	}
	
	getTenantCurrentFileStorage() {
		this.homepageDataService.getTenantDiskUsage().then(
			(data) => {
				if (data) {
					this.isErrorForStorageUsage = false;
					var isInfoUpdated = false;
					if (this.usedStorage !== data) {
						isInfoUpdated = true;
						this.usedStorage = data;
					}
				}
				if (isInfoUpdated) {
					this.isStorageWarningLevel = (this.usedStorage >= this.maxStorage * WARNING_PERCENT ) && (this.usedStorage < this.maxStorage);
					this.render();
				}
			},
			(error) => {
				this.isErrorForStorageUsage = true;
				logger.error('Error retrieving tenant current storage usage information from server: ' + error);
				this.render();
			}
		);
	}
	
	getTenantCurrentDataTransfer() {
		this.homepageDataService.getTenantDataTransferUsage().then(
			(data) => {
				if (data) {
					this.isErrorForDataUsage = false;
					var isInfoUpdated = false;
					if (this.usedData !== data) {
						isInfoUpdated = true;
						this.usedData = data;
					}
				}
				if (isInfoUpdated) {
					this.isDataWarningLevel = (this.usedData >= this.maxData * WARNING_PERCENT) && (this.usedData < this.maxData);
					this.render();
				}
			},
			(error) => {
				this.isErrorForDataUsage = true;
				logger.error('Error retrieving tenant current data transfer usage information from server: ' + error);
				this.render();
			}
		);
	}

	// Display usage info
	render() {
		// display storage dashboard information - usage display strings
		if (!this.isErrorForStorageUsage) {
			this.storageUsed = this.filter('number')(this.usedStorage, 1);
		}
		else {
			this.storageUsed = this.unavailableText;
		}
		this.storageMax = this.filter('number')(this.maxStorage);
		
		// display data transfer dashboard information - usage display strings
		if (!this.isErrorForDataUsage) {
			this.dataUsed = this.filter('number')(this.usedData, 1);
		}
		else {
			this.dataUsed = this.unavailableText;
		}
		this.dataMax = this.filter('number')(this.maxData);
	}
	
	setErrorMessage(key, amount) {
		var errorMessage = {};
		errorMessage.key = key;
		errorMessage.amount = amount;
		this.errorMessages.push(errorMessage);
	}

	// Return the color fill style for percentage usage
	getStorageUsagePercentStyle(){
		return {
			"height": (this.usedStorage / this.maxStorage * 100).toFixed(2) + '%'
		};
	}

    // Return the color fill style for percentage usage
    getDataTransferUsagePercentStyle(){
        return {
            "height": (this.usedData / this.maxData * 100).toFixed(2) + '%'
        };
    }
	
};

module.exports = {
	templateUrl: template,
	controller: ["$scope", "$filter", "$translate", "matchmedia", "tenantRegistryService", "contentService", "homepageDataService", "shellUtil", HubUsageController]
};



// WEBPACK FOOTER //
// ./app/components/hubUsage/hubUsage.component.js